import { Search } from '@/DTOS/Company/Search';
import request from '../../utils/request';

const CompanyService = {
  search: (search: Search) => {
    return request('/company/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    /** @type {any} */ id: any,
    formData: {
      contactPersons: {
        id: any;
        name: any;
        phone: any;
        email: any;
        role: any;
        isActive: any;
        workPlaceId?: any;
        companyId?: any;
        isDefaultOnInterventionFile?: any;
        receivesInterventionFileEmails?: any;
      }[];
      accountManagerId: any;
      type: any;
      name: any;
      country: any;
      locality: any;
      address: any;
      phone: any;
      email: any;
      bankAccount: any;
      bank: any;
      cnp: any;
      signature: any;
      companyGroupId: any;
      enumCompanyRankId: any;
      cui: any;
      registrationNumber: any;
      activityDescription: any;
      leadership: any;
      webAddress: any;
    }
  ) => {
    const handleFieldValue = (fieldValue: any) => {
      if (Array.isArray(fieldValue)) {
        return fieldValue;
      } else {
        return [fieldValue];
      }
    };
    return request('/company/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          contactPersons: formData.contactPersons.map((cp: any) => {
            return {
              id: cp.id ?? '',
              workPlaceId: cp.workPlaceId,
              companyId: cp.companyId,
              name: cp.name,
              phone: handleFieldValue(cp.phone),
              email: handleFieldValue(cp.email),
              role: handleFieldValue(cp.role),
              isActive: cp.isActive,
              isDefaultOnInterventionFile: cp.isDefaultOnInterventionFile,
              receivesInterventionFileEmails: cp.receivesInterventionFileEmails,
            };
          }),
          accountManagerId: formData.accountManagerId,
          type: formData.type,
          name: formData.name,
          country: formData.country,
          locality: formData.locality,
          address: formData.address,
          phone: handleFieldValue(formData.phone),
          email: handleFieldValue(formData.email),
          bankAccount: formData.bankAccount,
          bank: formData.bank,
          cnp: formData.cnp,
          signature: formData.signature,
          companyGroupId: formData.companyGroupId ?? null,
          enumCompanyRankId: formData.enumCompanyRankId ?? null,
          cui: formData.cui,
          registrationNumber: formData.registrationNumber,
          activityDescription: formData.activityDescription,
          leadership: formData.leadership,
          webAddress: formData.webAddress,
        },
      }),
    });
  },

  upload: (/** @type {any} */ file: any) => {
    return request(
      '/company/uploadFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
        },
        body: file,
      },
      true
    );
  },

  downloadFile: (/** @type {any} */ id: any) => {
    return request(
      '/company/downloadFile',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(id),
      },
      true
    );
  },

  print: (search: Search) => {
    return request(
      '/company/print',
      {
        method: 'POST',
        credentials: 'include',
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('authToken'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ request: { ...search } }),
      },
      true
    );
  },
};

export default CompanyService;
